import { type FirmDto } from '../dto';
import { type Firm } from '../models';
import { mapFirmSummaryFromDto } from './firm-summary-from-dto';

export function mapFirmFromDto(dto: FirmDto): Firm {
  return {
    ...mapFirmSummaryFromDto(dto),
    createdAt: new Date(dto.created_at),
    address: dto.address,
    phone: dto.phone,
    email: dto.email,
    contactName: dto.contact_name,
  };
}
